import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { REPORT_DATE_TYPES } from 'src/consumer/constants'
import { getFeeMapString } from '../utils'
import OverallReportComponent from './OverallReportComponent'

export function getFeeRelatedStringForClinicReport(currencyToFeeCollectedMap) {
  if (!currencyToFeeCollectedMap) return 'NA'

  return getFeeMapString({ currencyToFeeCollectedMap: currencyToFeeCollectedMap })
}

export function renderFeeRelatedDataForClinicReport(currencyToFeeCollectedMap) {
  return (
    <div className="report-item">
      {getFeeRelatedStringForClinicReport(currencyToFeeCollectedMap)}
    </div>
  )
}

export default function ClinicReportComponent({
  clinicLocation,
  allReports,
  reportType = REPORT_DATE_TYPES.day,
  getCorrectReportDateString,
  downloadButtonRef,
  allScreeners,
  accordionOpenAlways = false,
}) {
  const [reports, setReports] = useState()
  const [screeners, setScreeners] = useState()

  function getScreeners() {
    const mentorIdsToFind = [
      ...(clinicLocation?.doctors || [])?.map((doctor) => doctor?.id),
      ...(clinicLocation?.therapists || [])?.map((therapist) => therapist?.id),
    ]
    const foundScreeners = allScreeners?.filter((screener) =>
      mentorIdsToFind?.includes(screener?.id),
    )

    setScreeners(foundScreeners)
  }

  useEffect(() => {
    var reportToSet = allReports?.map((report) => {
      const foundReport = report?.reports?.find((r) => r.clinicLocationId === clinicLocation?.id)
      return { ...foundReport, reportEndTime: report?.endTime, reportStartTime: report?.startTime }
    })

    reportToSet?.sort((a, b) => dayjs.utc(b?.reportEndTime) - dayjs.utc(a?.reportEndTime))
    getScreeners()
    setReports(reportToSet)
  }, [allReports, clinicLocation, allScreeners, reportType])

  return (
    <OverallReportComponent
      entityTitle={`Location: ${clinicLocation?.nickName || clinicLocation?.title}`}
      reportType={reportType}
      reports={reports}
      downloadButtonRef={downloadButtonRef}
      screeners={screeners}
      accordionOpenAlways={accordionOpenAlways}
    />
  )
}
